import React, { useMemo, useState } from "react";
import PageSeo from "../components/PageSeo";
import { Helmet } from "react-helmet-async";

const products = [
  {
    id: 1,
    name: "Insta360 X3 Action Camera",
    price: 29990,
    category: "Electronics",
    sublabel: "Ride recording",
    featured: true,
    link: "https://amzn.to/4tPAvTB",
    image: "https://m.media-amazon.com/images/I/610NQUzk2xL._SX679_.jpg",
  },
  {
    id: 2,
    name: "Balaclava Face Mask & Arm Sleeves Combo",
    price: 349,
    category: "Riding Gear",
    sublabel: "Heat and dust protection",
    featured: false,
    link: "https://amzn.to/3O2QsGE",
    image: "https://m.media-amazon.com/images/I/61qMdqTzapL._AC_SR160,134_CB1169409_QL70_.jpg",
  },
  {
    id: 3,
    name: "Motorcycle Chain Cleaner Brush",
    price: 149,
    category: "Maintenance",
    sublabel: "Quick chain cleaning",
    featured: false,
    link: "https://amzn.to/4mcnvVp",
    image: "https://m.media-amazon.com/images/I/610XWnl+nXL._AC_UL320_.jpg",
  },
  {
    id: 4,
    name: "Tubeless Tyre Puncture Repair Kit",
    price: 298,
    category: "Maintenance",
    sublabel: "Emergency roadside fix",
    featured: true,
    link: "https://amzn.to/3PJAO3w",
    image: "https://m.media-amazon.com/images/I/61iuZ0CYSrL._AC_SR180,120_CB1169409_QL70_.jpg",
  },
  {
    id: 5,
    name: "Bike Phone Mount 360 Rotational",
    price: 279,
    category: "Accessories",
    sublabel: "Navigation ready",
    featured: false,
    link: "https://amzn.to/4dHg0DG",
    image: "https://m.media-amazon.com/images/I/41v8jCARUFL._AC_SR250,250_QL65_.jpg",
  },
  {
    id: 6,
    name: "Silicone Bike Seat Cushion",
    price: 899,
    category: "Comfort",
    sublabel: "Long-ride support",
    featured: false,
    link: "https://amzn.to/4c6piYM",
    image: "https://m.media-amazon.com/images/I/81VVR8VTqXL._AC_UL320_.jpg",
  },
  {
    id: 7,
    name: "Probiker Protective Gloves",
    price: 259,
    category: "Riding Gear",
    sublabel: "Grip and protection",
    featured: true,
    link: "https://amzn.to/4tJTfnq",
    image: "https://m.media-amazon.com/images/I/71L1LaH5mUL._AC_UL320_.jpg",
  },
  {
    id: 8,
    name: "Adjustable Motorcycle Mirrors Set",
    price: 698,
    category: "Accessories",
    sublabel: "Visibility upgrade",
    featured: false,
    link: "https://amzn.to/3QvWUqi",
    image: "https://m.media-amazon.com/images/I/71HG77jdzwL._AC_UL320_.jpg",
  },
  {
    id: 9,
    name: "Camera Clamp Handlebar Mount",
    price: 1890,
    category: "Electronics",
    sublabel: "Stable camera setup",
    featured: false,
    link: "https://amzn.to/41nGe6P",
    image: "https://m.media-amazon.com/images/I/61iheJkgf1L._AC_UY218_.jpg",
  },
  {
    id: 10,
    name: "Full Face Riding Helmet",
    price: 2499,
    category: "Riding Gear",
    sublabel: "Daily safety essential",
    featured: true,
    link: "https://amzn.to/48f1wHJ",
    image: "https://m.media-amazon.com/images/I/61fzUXgm6hL._AC_UL320_.jpg",
  },
  {
    id: 11,
    name: "Motorcycle Saddle Bag Set",
    price: 3299,
    category: "Accessories",
    sublabel: "Weekend luggage setup",
    featured: false,
    link: "https://amzn.to/4sq17JC",
    image: "https://m.media-amazon.com/images/I/61fVtQL0odL._AC_UL320_.jpg",
  },
  {
    id: 12,
    name: "Anti Fog Helmet Visor Film",
    price: 399,
    category: "Riding Gear",
    sublabel: "Clear rainy visibility",
    featured: false,
    link: "https://amzn.to/3Q1EHkq",
    image: "https://m.media-amazon.com/images/I/51N45C5BNhL._AC_UL320_.jpg",
  },
  {
    id: 13,
    name: "Portable Bike Air Compressor",
    price: 1099,
    category: "Maintenance",
    sublabel: "Fast tyre inflation",
    featured: true,
    link: "https://amzn.to/3NZSI1s",
    image: "https://m.media-amazon.com/images/I/61MDYqBe4iL._AC_UY218_.jpg",
  },
  {
    id: 14,
    name: "LED Auxiliary Light Pair",
    price: 988,
    category: "Electronics",
    sublabel: "Night ride upgrade",
    featured: false,
    link: "https://amzn.to/4ceRaIL",
    image: "https://m.media-amazon.com/images/I/718Cxzxc37L._AC_UY218_.jpg",
  },
  {
    id: 15,
    name: "Riding Knee and Elbow Guard Set",
    price: 959,
    category: "Riding Gear",
    sublabel: "Extra protection on highways",
    featured: false,
    link: "https://amzn.to/4vmXmqP",
    image: "https://m.media-amazon.com/images/I/71M8bFJf-sL._AC_UL320_.jpg",
  },
  {
    id: 16,
    name: "Tank Pad Protector Kit",
    price: 249,
    category: "Accessories",
    sublabel: "Protects tank from scratches",
    featured: false,
    link: "https://amzn.to/4swn0GZ",
    image: "https://m.media-amazon.com/images/I/61ozsyuOx9L._AC_UL320_.jpg",
  },
  {
    id: 17,
    name: "Microfiber Cleaning Cloth Pack",
    price: 199,
    category: "Maintenance",
    sublabel: "Quick visor and bike wipe",
    featured: false,
    link: "https://amzn.to/41WdiTA",
    image: "https://m.media-amazon.com/images/I/81X0ylF1b+L._AC_UL320_.jpg",
  },
  {
    id: 18,
    name: "Waterproof Riding Jacket Cover",
    price: 549,
    category: "Comfort",
    sublabel: "Rain-ready commuting layer",
    featured: false,
    link: "https://amzn.to/4vpzVx9",
    image: "https://m.media-amazon.com/images/I/51m2sVkmVeL._AC_UL320_.jpg",
  },
  {
    id: 19,
    name: "Jaw-Grip Waterproof Bike/Motorcycle/Scooter Mobile Phone Holder Mount with Fast USB 3.0 Charger,",
    price: 1799,
    category: "Electronics",
    sublabel: "Charge phone on the go",
    featured: false,
    link: "https://amzn.to/4tG4EEr",
    image: "https://m.media-amazon.com/images/I/51CTbANhkbL._AC_UY218_.jpg",
  },
  {
    id: 20,
    name: "Gel Grip Handle Covers",
    price: 449,
    category: "Comfort",
    sublabel: "Reduced hand fatigue",
    featured: false,
    link: "https://amzn.to/3OBmbPn",
    image: "https://m.media-amazon.com/images/I/81WGiDO6H5L._AC_UL320_.jpg",
  },
];

const categoryAccent = {
  All: "var(--brand)",
  Electronics: "#3B82F6",
  "Riding Gear": "var(--brand)",
  Maintenance: "var(--warning)",
  Accessories: "#06B6D4",
  Comfort: "var(--success)",
};

const priceBands = [
  { id: "all", label: "Any price", min: 0, max: Infinity },
  { id: "budget", label: "Under Rs 500", min: 0, max: 500 },
  { id: "mid", label: "Rs 500 - 2,000", min: 500, max: 2000 },
  { id: "premium", label: "Above Rs 2,000", min: 2000, max: Infinity },
];

const formatPrice = (price) => `Rs ${price.toLocaleString("en-IN")}`;

export default function Shop() {
  const [activeCategory, setActiveCategory] = useState("All");
  const [activePriceBand, setActivePriceBand] = useState("all");
  const [search, setSearch] = useState("");

  const categories = useMemo(() => {
    const uniqueCategories = [...new Set(products.map((product) => product.category))];
    return ["All", ...uniqueCategories];
  }, []);

  const filteredProducts = useMemo(() => {
    const selectedBand = priceBands.find((band) => band.id === activePriceBand) || priceBands[0];
    const query = search.trim().toLowerCase();

    return products.filter((product) => {
      const matchesCategory = activeCategory === "All" || product.category === activeCategory;
      const matchesPrice = product.price >= selectedBand.min && product.price < selectedBand.max;
      const matchesSearch =
        !query ||
        product.name.toLowerCase().includes(query) ||
        product.category.toLowerCase().includes(query) ||
        product.sublabel.toLowerCase().includes(query);

      return matchesCategory && matchesPrice && matchesSearch;
    });
  }, [activeCategory, activePriceBand, search]);

  const featuredCount = products.filter((product) => product.featured).length;

  return (
    <div style={{ padding: "32px 36px", maxWidth: 1180 }}>
      <Helmet>
  <title>Bike Accessories Shop India | MotoHub India</title>
  <meta name="robots" content="index, follow" />
</Helmet>
     <PageSeo
  title="Bike Accessories Shop India | Riding Gear, Helmets & Bike Tools | MotoHub India"
  description="Shop best bike accessories, riding gear, helmets, gloves, maintenance tools, and motorcycle travel essentials in India. Explore budget to premium gear on MotoHub India."
  keywords={[
    "bike accessories India",
    "riding gear India",
    "motorcycle accessories shop",
    "helmet gloves bike gear India",
    "bike touring accessories India",
    "motorcycle tools India",
    "bike maintenance products India",
    "best bike gear India online",
    "motorcycle shopping India",
    "MotoHub India shop"
  ]}
  path="/shop"
/>
      <div className="fade-up" style={{ display: "flex", justifyContent: "space-between", gap: 20, marginBottom: 24, alignItems: "flex-end", flexWrap: "wrap" }}>
        <div>
          <div style={{ fontFamily: "var(--font-display)", fontSize: 38, letterSpacing: 1 }}>GEAR SHOP</div>
          <div style={{ fontSize: 13, color: "var(--text2)", marginTop: 4 }}>
            Category-based gear picks for riders, tourers, and daily commuters.
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(120px, 1fr))", gap: 10, minWidth: 260 }}>
          <div style={{ background: "var(--bg2)", border: "1px solid var(--border)", borderRadius: "var(--radius-lg)", padding: "14px 16px" }}>
            <div style={{ fontSize: 23, fontWeight: 600, color: "var(--brand)" }}>{products.length}</div>
            <div style={{ fontSize: 12, color: "var(--text3)" }}>Products</div>
          </div>
          <div style={{ background: "var(--bg2)", border: "1px solid var(--border)", borderRadius: "var(--radius-lg)", padding: "14px 16px" }}>
            <div style={{ fontSize: 23, fontWeight: 600, color: "var(--warning)" }}>{featuredCount}</div>
            <div style={{ fontSize: 12, color: "var(--text3)" }}>Featured</div>
          </div>
        </div>
      </div>

      <div className="fade-up-1" style={{ background: "linear-gradient(135deg, rgba(232,76,30,0.14), rgba(255,255,255,0.02))", border: "1px solid var(--border2)", borderRadius: "var(--radius-lg)", padding: 18, marginBottom: 20 }}>
        <div style={{ display: "grid", gridTemplateColumns: "minmax(240px, 1.5fr) minmax(220px, 1fr)", gap: 12, marginBottom: 14 }}>
          <input
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="Search by product, use case, or category"
          />
          <select value={activePriceBand} onChange={(event) => setActivePriceBand(event.target.value)}>
            {priceBands.map((band) => (
              <option key={band.id} value={band.id}>
                {band.label}
              </option>
            ))}
          </select>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          {categories.map((category) => {
            const isActive = category === activeCategory;
            const accent = categoryAccent[category] || "var(--brand)";
            return (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                style={{
                  padding: "8px 14px",
                  borderRadius: 999,
                  border: `1px solid ${isActive ? accent : "var(--border)"}`,
                  background: isActive ? accent : "var(--bg2)",
                  color: isActive ? "#fff" : "var(--text2)",
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                {category}
              </button>
            );
          })}
        </div>
      </div>

      <div className="fade-up-2" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, flexWrap: "wrap", gap: 10 }}>
        <div style={{ fontSize: "13px", color: "var(--text2)", textTransform: "uppercase", letterSpacing: 1.2 }}>
          Showing {filteredProducts.length} product{filteredProducts.length === 1 ? "" : "s"}
        </div>
        <div style={{ fontSize: 12, color: "var(--text3)" }}>
          Filters: {activeCategory} {activePriceBand !== "all" ? `� ${priceBands.find((band) => band.id === activePriceBand)?.label}` : ""}
        </div>
      </div>

      <div className="fade-up-3" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 16 }}>
        {filteredProducts.map((product) => {
          const accent = categoryAccent[product.category] || "var(--brand)";
          return (
            <div
              key={product.id}
              style={{
                background: "var(--bg2)",
                border: "1px solid var(--border)",
                borderRadius: "var(--radius-lg)",
                padding: 14,
                display: "flex",
                flexDirection: "column",
                minHeight: 100,
              }}
            >
              <div style={{ position: "relative", marginBottom: 12 }}>
                <img
                  src={product.image}
                  alt={product.name}
                  style={{ width: "100%", height: 180, objectFit: "cover", borderRadius: 10, background: "var(--bg3)" }}
                />
                <div style={{ position: "absolute", top: 10, left: 10, display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <span style={{ background: accent, color: "#fff", fontSize: 11, padding: "4px 8px", borderRadius: 999 }}>
                    {product.category}
                  </span>
                  {product.featured && (
                    <span style={{ background: "rgba(0,0,0,0.68)", color: "#fff", fontSize: 11, padding: "4px 8px", borderRadius: 999 }}>
                      Featured
                    </span>
                  )}
                </div>
              </div>

              <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                <div style={{ fontSize: 16, fontWeight: 600, lineHeight: 1.35, marginBottom: 6 }}>{product.name}</div>
                <div style={{ fontSize: 12, color: "var(--text3)", marginBottom: 12 }}>{product.sublabel}</div>
                <div style={{ fontSize: 22, fontWeight: 700, color: accent, marginBottom: 14 }}>{formatPrice(product.price)}</div>

                <a href={product.link} target="_blank" rel="noreferrer" style={{ marginTop: "auto", textDecoration: "none" }}>
                  <button
                    style={{
                      width: "100%",
                      background: "var(--brand)",
                      color: "#fff",
                      padding: "11px 14px",
                      borderRadius: "var(--radius)",
                      fontSize: 14,
                      fontWeight: 600,
                    }}
                  >
                    View Product
                  </button>
                </a>
              </div>
            </div>
          );
        })}
      </div>

      {filteredProducts.length === 0 && (
        <div className="fade-up-4" style={{ marginTop: 18, background: "var(--bg2)", border: "1px dashed var(--border2)", borderRadius: "var(--radius-lg)", padding: 24, textAlign: "center" }}>
          <div style={{ fontSize: 17, fontWeight: 600, marginBottom: 6 }}>No products match these filters</div>
          <div style={{ fontSize: 13, color: "var(--text2)", marginBottom: 14 }}>
            Try another category or widen the price range.
          </div>
          <button
            onClick={() => {
              setActiveCategory("All");
              setActivePriceBand("all");
              setSearch("");
            }}
            style={{ background: "var(--brand)", color: "#fff", padding: "10px 18px", borderRadius: "var(--radius)", fontSize: 14, fontWeight: 600 }}
          >
            Reset Filters
          </button>
        </div>
      )}

      <p style={{ marginTop: 26, fontSize: 12, color: "var(--text3)" }}>
        As an Amazon Associate, MotoHub India may earn from qualifying purchases.
      </p>
    </div>
  );
}
